import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminShared.css";
import { API_BASE_URL } from "../config";

export default function AdminTestimonialsPage() {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [form, setForm] = useState({ name: "", message: "", rating: 5 });
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchTestimonials = useCallback(async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API_BASE_URL}/api/testimonials`);
      const data = await res.json();
      setList(Array.isArray(data) ? data.reverse() : []);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => {
    const adminInfo = localStorage.getItem("adminInfo");
    if (!adminInfo) return navigate("/admin");
    fetchTestimonials();
  }, [fetchTestimonials, navigate]);

  const handleAction = async () => {
    if (!form.name || !form.message) return alert("All telemetry fields required.");
    const url = editId
      ? `${API_BASE_URL}/api/testimonials/${editId}`
      : `${API_BASE_URL}/api/testimonials`;
    const method = editId ? "PUT" : "POST";

    try {
      await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form)
      });
      setForm({ name: "", message: "", rating: 5 });
      setEditId(null);
      fetchTestimonials();
    } catch (err) { alert("Operation failed"); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Purge this reputation fragment?")) return;
    try {
      await fetch(`${API_BASE_URL}/api/testimonials/${id}`, { method: "DELETE" });
      fetchTestimonials();
    } catch (err) { console.error(err); }
  };

  const handleEdit = (t) => {
    setForm({ name: t.name, message: t.message, rating: t.rating });
    setEditId(t._id);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (loading && list.length === 0) return <div className="admin-list-container"><p style={{padding: '100px', textAlign: 'center'}}>⏳ Syncing Brand Reputation Data...</p></div>;

  return (
    <div className="admin-list-container">
      <header className="admin-list-header">
        <div className="header-left-group">
          <button className="admin-back-btn" onClick={() => navigate("/admin/panel")}>←</button>
          <img src="/logo.png" alt="FlyTutor" className="admin-header-logo" />
          <h1 className="admin-header-title">Reputation Nexus</h1>
        </div>
        <div className="module-badge" style={{ background: '#fb923c' }}>Reviews</div>
      </header>

      <div className="admin-list-content">
         <div className="admin-info-bar">
          <div className="admin-user-tag">
            <div className="dot" style={{ background: '#fb923c' }}></div>
            Operator: Brand Identity Node
          </div>
          <div className="admin-status-badge" style={{ background: '#fff7ed', color: '#9a3412', fontSize: '0.75rem', fontWeight: 800 }}>
             {list.length} VERIFIED FRAGMENTS
          </div>
        </div>

        <div className="admin-dual-layout">
            {/* FORM SIDE */}
            <div className="admin-form-elite side-form" style={{ position: 'sticky', top: '20px', height: 'fit-content' }}>
                <h3 style={{ margin: '0 0 10px 0', fontWeight: 800 }}>{editId ? "SYNC FRAGMENT" : "REGISTER FRAGMENT"}</h3>
                
                <label>
                  Identifier Name 
                  <input value={form.name} onChange={e => setForm({...form, name: e.target.value})} placeholder="Source Identity" />
                </label>

                <label>
                  Sentiment Rating 
                  <select value={form.rating} onChange={e => setForm({...form, rating: Number(e.target.value)})}>
                      {[5,4,3,2,1].map(n => <option key={n} value={n}>{"⭐".repeat(n)} ({n}.0 Index)</option>)}
                  </select>
                </label>

                <label>
                  Fragment Content 
                  <textarea value={form.message} onChange={e => setForm({...form, message: e.target.value})} placeholder="Sentiment Payload" style={{ height: '150px' }} />
                </label>
                
                <div style={{ display: 'flex', gap: '15px' }}>
                    <button className="btn-primary-elite" style={{ flex: 1, background: '#fb923c' }} onClick={handleAction}>
                        {editId ? "Confirm Sync" : "Deploy"}
                    </button>
                    {editId && (
                        <button className="btn-update" style={{ background: '#f1f5f9', border: 'none' }} onClick={() => { setEditId(null); setForm({name:"", message:"", rating:5}); }}>Cancel</button>
                    )}
                </div>
            </div>

            {/* LIST SIDE */}
            <div className="admin-table-wrapper" style={{ minWidth: 0 }}>
                <table className="elite-table">
                    <thead>
                        <tr>
                            <th>Source</th>
                            <th>Payload</th>
                            <th>Rating</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {list.map(t => (
                            <tr key={t._id}>
                                <td style={{ width: '150px' }}>
                                    <div style={{ fontWeight: 700 }}>{t.name}</div>
                                    <div style={{ fontSize: '0.7rem', color: '#94a3b8' }}>VERIFIED-CLIENT</div>
                                </td>
                                <td>
                                    <div style={{ fontSize: '0.9rem', color: '#475569', lineHeight: '1.5' }}>{t.message}</div>
                                </td>
                                <td style={{ width: '120px' }}>
                                    <div style={{ color: '#fbbf24' }}>{"⭐".repeat(t.rating)}</div>
                                </td>
                                <td style={{ width: '120px' }}>
                                    <div style={{ display: 'flex', gap: '8px' }}>
                                        <button className="action-btn-elite btn-update" onClick={() => handleEdit(t)}><span>✏️</span></button>
                                        <button className="action-btn-elite btn-delete" onClick={() => handleDelete(t._id)}><span>🗑️</span></button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
      </div>
    </div>
  );
}
